"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailActionButton = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const evidence_defaults_context_1 = require("../../evidence-defaults/evidence-defaults-context");
const detail_context_1 = require("../../detail/detail-context");
const detail_types_1 = require("../../detail/detail-types");
const detail_toolbar_button_1 = require("../../detail/detail-toolbar-button");
const action_button_1 = require("../action-button");
exports.DetailActionButton = react_1.forwardRef(function DetailActionButton({ modes = [detail_types_1.DetailMode.VIEW], refreshAfterConfirm = true, refreshAfterClose = false, onSuccess, onShouldShow = lodash_1.stubTrue, apiCall, closeCallback: onClose, ButtonComponent, disabled, detailValidationSchema, ...restProps }, ref) {
    var _a;
    const { source, mode, validate, refreshAll } = react_1.useContext(detail_context_1.DetailContext);
    const defaults = react_1.useContext(evidence_defaults_context_1.EvidenceDefaultsContext);
    const DetailToolbarButtonComponent = (_a = ButtonComponent !== null && ButtonComponent !== void 0 ? ButtonComponent : defaults.ToolbarButtonComponent) !== null && _a !== void 0 ? _a : detail_toolbar_button_1.DetailToolbarButton;
    const defaultOnSuccess = event_callback_hook_1.useEventCallback(async () => {
        if (refreshAfterConfirm) {
            refreshAll();
        }
    });
    const handleSuccess = onSuccess !== null && onSuccess !== void 0 ? onSuccess : defaultOnSuccess;
    const defaultOnClose = event_callback_hook_1.useEventCallback(() => {
        if (refreshAfterClose) {
            refreshAll();
        }
    });
    const handleClose = onClose !== null && onClose !== void 0 ? onClose : defaultOnClose;
    const defaultApiCall = event_callback_hook_1.useEventCallback((formData) => {
        return apiCall(source.data.id, formData);
    });
    const handleApiCall = apiCall && defaultApiCall;
    const combinedShouldShow = react_1.useCallback(() => {
        return modes.includes(mode) && onShouldShow();
    }, [modes, mode, onShouldShow]);
    const handleBeforeDialog = event_callback_hook_1.useEventCallback(async () => {
        if (detailValidationSchema !== undefined) {
            const errors = await validate(true, detailValidationSchema);
            return errors.length === 0;
        }
        else {
            return true;
        }
    });
    return (react_1.default.createElement(action_button_1.ActionButton, Object.assign({ ButtonComponent: DetailToolbarButtonComponent, onBeforeDialog: handleBeforeDialog, onSuccess: handleSuccess, onShouldShow: combinedShouldShow, apiCall: handleApiCall, closeCallback: handleClose, ref: ref }, restProps)));
});
//# sourceMappingURL=detail-action-button.js.map